module.exports = __webpack_public_path__ + "img/waves-6.89dac83d.jpg";